import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  openMailTo: {
    id: 'Open a Mailto Link to the Members Email Address',
    defaultMessage: 'Open a Mailto Link to the Members Email Address',
  },
});

export const MailTo = ({ email, className }) => {
  let decoded;
  if (!email.includes('@')) {
    const buffer = Buffer.from(email, 'base64');
    decoded = buffer.toString('ascii');
  }

  const intl = useIntl();

  const rot10 = (s) => {
    return s.replace(
      /[a-z]/g,
      (c) =>
        'abcdefghijklmnopqrstuvwxyz'['klmnopqrstuvwxyzabcdefghij'.indexOf(c)],
    );
  };

  const onClickEmail = () => {
    const emailClear = email.includes('@') ? email : rot10(decoded);
    window.open(`mailto:${emailClear}`, '_self');
  };

  return (
    <span
      className={className}
      onClick={() => onClickEmail()}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onClickEmail();
        }
      }}
      title={intl.formatMessage(messages.openMailTo)}
      role="button"
      tabIndex={0}
    >
      E-Mail
    </span>
  );
};
